// extracted by mini-css-extract-plugin
module.exports = {"component":"styles_component__46F4L","container":"styles_container__ORVrH","heading":"styles_heading__N92FH","image":"styles_image__xAuvH"};